import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Icon from 'dpl/common/components/Icon';

import SearchMenuDrawer from '../components/SearchMenuDrawer';
import useInitialHeaderState from '../hooks/useInitialHeaderState';

export default function NavMenuBreedSearchContainer({
  className,
  onParentClose
}) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { hasUnifiedMobileNav, searchBreedName } = useInitialHeaderState();

  const shouldUsePlaceholderLabel = hasUnifiedMobileNav || !searchBreedName;

  function openDrawer() {
    setIsDrawerOpen(true);
  }

  function closeDrawer() {
    setIsDrawerOpen(false);
  }

  return (
    <div className={classnames('NavMenuBreedSearchContainer', className)}>
      <button
        type="button"
        className={classnames(
          'flex items-center gap-12 font-16 bg-white ba br3 b--default w-100 pv3 ph3',
          shouldUsePlaceholderLabel ? 'tertiary' : 'default-color'
        )}
        onClick={openDrawer}
      >
        <Icon
          className="primary"
          name="fetch-search"
          height="20px"
          width="20px"
        />
        {shouldUsePlaceholderLabel ? 'Search a breed' : searchBreedName}
      </button>
      {isDrawerOpen && (
        <SearchMenuDrawer onClose={closeDrawer} onParentClose={onParentClose} />
      )}
    </div>
  );
}

NavMenuBreedSearchContainer.propTypes = {
  className: PropTypes.string,
  onParentClose: PropTypes.func
};

NavMenuBreedSearchContainer.defaultProps = {
  className: null,
  onParentClose: null
};
